import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, tap, map, catchError } from 'rxjs/operators';

import * as user from './user.actions';
import * as loader from './loader.actions';
import { State } from './user.reducer';
import { UserService } from '../service';

@Injectable()
export class UserEffects {
  private actions = inject(Actions);
  private store = inject<Store<State>>(Store);
  private userService = inject(UserService);

  loadCommunities = createEffect(() =>
    this.actions.pipe(
      ofType(user.loadCommunities),

      tap(() => {
        this.store.dispatch(loader.loadStart(user.loadCommunities.type));
      }),
      switchMap((): Observable<Action> => {
        return this.userService.loadCommunities().pipe(
          map(
            (data: any) => {
              this.store.dispatch(loader.loadStop(user.loadCommunities.type));
              return user.loadCommunitiesSuccess(data);
            },
            catchError((message) => {
              this.store.dispatch(loader.loadError(user.loadCommunities.type, message));
              return [user.loadCommunitiesFail([])];
            }),
          ),
        );
      }),
    ),
  );
}
